<template>
  <div class="base-layout">
    <slot />
  </div>
</template>
<script>
import TheSideBar from './the-sidebar.vue'
import TheTopBar from './the-topbar.vue'

export default {
  components: {
    TheSideBar, 
    TheTopBar,
  },
}
</script>

<style lang="scss" scoped>

.base-layout {
  width: 100%;
}
</style>